export default angular
  .module('st.Integrations.Jitsi', [])
  .service('jitsiService', ($http, dataService, JITSI) => ({
    create: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        JITSI.API.CREATE,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('JITSI', {
    API: {
      CREATE: '/api/v1/integrations/jitsi/create'
    }
  });
